//DELETE

import { api } from "./urlApi";

export const deleteRol = async (rol) => {
  const url = `${api}/rol/delete.php`;

  try {
    const resp = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rol),
    });

    const data = await resp.json();

    return data;
  } catch (error) {
    return error;
  }
};
